import { APP_CONFIG } from '@/constants/app';
import {
  NotificationsFilters,
  NotificationsPagination,
  NotificationsResponse,
  UnreadCountResponse,
  UpdateReadStatusDto,
} from '@/types/notification.types';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

// Create axios instance for notification service
const notificationApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl + '/notifications',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(notificationApi);

export const notificationService = {
  getNotifications: async (
    pagination: NotificationsPagination,
    filters: NotificationsFilters = {}
  ): Promise<NotificationsResponse> => {
    const searchParams = new URLSearchParams();

    searchParams.append('skip', pagination.skip.toString());
    searchParams.append('take', pagination.limit.toString());

    if (filters.search) {
      searchParams.append('search', filters.search);
    }

    if (filters.status && filters.status !== 'all') {
      searchParams.append('status', filters.status);
    }

    if (filters.type && filters.type !== 'all') {
      searchParams.append('type', filters.type);
    }

    if (filters.isRead !== undefined) {
      searchParams.append('isRead', filters.isRead.toString());
    }

    const response = await notificationApi.get<NotificationsResponse>(
      `?${searchParams.toString()}`
    );
    return response.data;
  },

  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response =
      await notificationApi.get<UnreadCountResponse>('/unread-count');
    return response.data;
  },

  updateReadStatus: async (
    notificationId: string,
    data: UpdateReadStatusDto
  ): Promise<void> => {
    await notificationApi.patch(`/${notificationId}/read-status`, data);
  },

  markAllAsRead: async (): Promise<void> => {
    await notificationApi.post('/mark-all-read');
  },

  deleteNotification: async (notificationId: string): Promise<void> => {
    await notificationApi.delete(`/${notificationId}`);
  },
};
